import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { toggleToggleList } from 'common/Prose/utils/toggleToggleList'
import { computed } from 'mobx'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext, SelectionType } from 'stores/EditorState'

export function useToggleBlockToggle(view: EditorView): ButtonHook {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!
  const { schema } = view.state

  const active = computed(() => almanacState.selectionIncludesSomeNodeTypes(schema.nodes.toggle_list)).get()
  const isDisabled = almanacState.selectionType === SelectionType.Cell

  return { active, handleClick: () => toggleToggleList(view), disabled: isDisabled }
}
